import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';

import { useAppDispatch, useAppSelector } from '@/features';
import { closeModal } from '@/features/slice/event/event-slice';
import { useEditBrandMutation } from '@/features/slice/products/brand/brand-api-slice';
import { ProductBrandDto } from '@/types/products';

import { BrandSchema } from '../brand-schema';

export const useEditBrand = () => {
    const brandData = useAppSelector((state) => state.eventSlice.modalData);
    const form = useForm({
        resolver: zodResolver(BrandSchema),
        defaultValues: {
            name: brandData.name || '',
            description: brandData.description || '',
            id: brandData.id,
        },
    });
    const [editBrand, { isLoading, isSuccess, isError }] =
        useEditBrandMutation();

    const {
        handleSubmit,
        formState: { errors },
    } = form;
    const dispatch = useAppDispatch();
    const onSubmit = async (value: ProductBrandDto) => {
        const data = await editBrand({
            name: value.name,
            description: value.description,
            id: brandData.id,
        }).unwrap();

        if (data.message === 'Success') {
            toast(data.data, {
                style: {
                    background: 'green',
                    color: 'white',
                },
            });
            dispatch(closeModal());
        }

        if (isError) {
            toast.error('error');
        }
    };

    return {
        handleSubmit: handleSubmit(onSubmit),
        form,
        isLoading,
        errors,
        isSuccess,
    };
};
